<template lang="pug">
  v-card.preview-template
    v-card-text.media-preview-container.px-0.py-0
      slot(name="media-item")
    v-card-actions.justify-center
      v-flex
        slot(name="card-actions")
</template>

<script>
export default {
  name: 'PreviewTemplate',
};
</script>

<style lang="scss">
.preview-template {
  width: 100%;

  .v-avatar {
    font-size: 13px;
  }

  .photo-caption-input {
    position: relative;
    display: block;
    width: 100%;
    height: 47px;
    min-height: 47px;
    padding: 6px 0;
    overflow: auto;
    font-size: 13px;
    border-bottom: 1px solid var(--color-border-01);
    cursor: text;

    &[contentEditable=true]:empty:not(:focus)::before {
      color: #666;
      content: attr(placeholder);
    }
  }

  .pho-textarea {
    height: 96px;
  }
}
</style>
